/* eslint-disable camelcase */
import Intercom, { shutdown } from '@intercom/messenger-js-sdk';
import type { User } from 'services/FirebaseService/auth';

const MS_PER_SECOND = 1000;

export const initializeIntercom = (user: User) => {
  if (import.meta.env.VITE_CLAIMSCORE_ENV !== 'prod') return;

  Intercom({
    app_id: import.meta.env.VITE_INTERCOM_APP_ID,
    user_id: user.uid,
    name: user.displayName ?? '',
    email: user.email ?? '',
    created_at: Math.floor(
      new Date(user.metadata.creationTime ?? 0).getTime() / MS_PER_SECOND,
    ),
  });
};

export const shutdownIntercom = () => shutdown();
